import * as React from 'react';
import PropTypes from 'prop-types';
export default function ExtrasFunnelProvider({
  children
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
ExtrasFunnelProvider.propTypes = {
  children: PropTypes.node.isRequired
};